import getServerErrorMessage from 'app/utilities/getServerErrorMessage';
import { SagaIterator } from 'redux-saga';
import {
  all,
  call,
  cancel,
  cancelled,
  fork,
  put,
  take,
} from 'redux-saga/effects';

import { updatePasswordAPIRequest } from '../api';
import { TSignInDTO } from '../types';
import {
  cancelAuthTask,
  clearError,
  clearSucces,
  endAuthTask,
  onError,
  onSuccess,
  signUpSuccess,
  startAuthTask,
  updatePasswordRequest,
} from './auth-slice';

export function* updatePassword(payload: TSignInDTO): SagaIterator {
  try {
    yield put(startAuthTask());
    yield call(updatePasswordAPIRequest, payload);
    yield all([
      put(signUpSuccess()),
      put(clearError()),
      put(onSuccess('Password reset successful.')),
    ]);
  } catch (error) {
    const errorMsg = getServerErrorMessage(error);
    yield all([put(onError(errorMsg)), put(clearSucces())]);
  } finally {
    if (yield cancelled()) {
      yield all([put(clearError()), put(clearSucces())]);
    }

    yield put(endAuthTask());
  }
}

export function* updatePasswordFlow(): SagaIterator {
  while (true) {
    const { payload } = yield take(updatePasswordRequest);
    const updatePasswordTask = yield fork(updatePassword, payload);
    const nextAction = yield take([cancelAuthTask, endAuthTask]);
    if (nextAction.type === cancelAuthTask.type) {
      yield cancel(updatePasswordTask);
    }
  }
}
